<template>
    <div class="acountStatus"> 
        <div class="mainTitle text-center my-3">
            <h3 class="mb-4">{{$t('ClosedTrades')}}</h3> 
        </div>
        <div class="mapIco-list-table mt-4">
            <app-close-trades :pageName="'close-trade'"></app-close-trades>
        </div>
    </div>   
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import closeTrades from '../shared/tradingAccounts/close_trades_listing'
    export default {
        name: 'Close-Trade',
        mixins: [fxViewMixins],
        data() {
            return {
            }
        },
        components: {
            appCloseTrades : closeTrades
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingAccounts/close_trades_listing.vue